import { render, staticRenderFns } from "./MosaicoView.vue?vue&type=template&id=028ae6e6&scoped=true"
import script from "./MosaicoView.vue?vue&type=script&lang=js"
export * from "./MosaicoView.vue?vue&type=script&lang=js"
import style0 from "./MosaicoView.vue?vue&type=style&index=0&id=028ae6e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ae6e6",
  null
  
)

export default component.exports